
<mat-card>
  <mat-card-header>
    <mat-card-title>Applied Tags</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <adf-tag-node-list [nodeId]="nodeId" [limitTagsDisplayed]="false" (results)="setExistingTags($event)" #tagListComponent> </adf-tag-node-list>
  </mat-card-content>
</mat-card>

<mat-card>
  <mat-card-header>
    <mat-card-title>Add Tag</mat-card-title>
  </mat-card-header>

  <mat-card-content>
      <mat-chip-listbox class="adf-tag-chips-list">
        <span
          class="adf-list-tag"
          *ngFor="let currentEntry of tagsEntries; let idx = index"
        >
            <mat-chip class="adf-primary-background-color">
              <span id="tag_name_{{ idx }}">{{ currentEntry.entry.tag }}</span>
                <mat-icon *ngIf="!existingTag(currentEntry)"
                  color="primary"
                  id="add-tag"
                  (click)="addTag(currentEntry.entry.tag)"
                  mat-button
                >
                  add_circle_outline
            </mat-icon>
            </mat-chip>
          </span>
      </mat-chip-listbox>

      <div class="adf-tag-list-controls">
        <button
          *ngIf="!isSizeMinimum"
          [disabled]="isLoading"
          data-automation-id="show-fewer-tags"
          mat-icon-button
          (click)="loadLessTags()"
        >
          <mat-icon>keyboard_arrow_up</mat-icon>
        </button>
        <button
          *ngIf="pagination.hasMoreItems"
          [disabled]="isLoading"
          data-automation-id="show-more-tags"
          mat-icon-button
          (click)="loadMoreTags()"
        >
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
      </div>

  </mat-card-content>
  </mat-card>
